{
  "help": "مساعدة",
  "info": "معلومات"
}
